import React, { useState, useEffect } from "react";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import Card from "react-bootstrap/Card";
import Goals from "./Goals";
import LetterContainer from "./LetterContainer";
import GameStart from "../../utils/GameStart";
import BackToGameList from "../../utils/BackToGameList";
import { HTML5Backend } from 'react-dnd-html5-backend'

function LetterScramble() {
  //settings
  const [timer, setTimer] = useState();
  const [errorChecking, setErrorChecking] = useState(true);
  const [allowImages, setAllowImages] = useState();
  //game start variables
  const [triggerTimer, setTriggerTimer] = useState();
  const [time, setTime] = useState(0);
  const [play, setPlay] = useState(false);
  const [resetGame, setResetGame] = useState(0);
  const [timesPlayed, setTimesPlayed] = useState(0);
  const [openGameStartModal, setOpenGameStartModal] = useState();
  //page variables
  const [letters, setLetters] = useState([]);
  const [phrase, setPhrase] = useState();
  const [word, setWord] = useState({
    id: "",
    answer: "",
    word: "",
  });
  const [dndEngine, setDNDEngine] = useState();
  const [dndEngineReady, setDNDEngineReady] = useState(false);

  const handleGetData = async () => {
    const response = await makeGetRequest(
      urls.letterScramble + "?active=True",
      "",
      true
    );
    const rnd = Math.floor(Math.random() * response.data.length);
    setPhrase(response.data[rnd].phrase);
    setWord({
      id: response.data[rnd].id,
      word: response.data[rnd].word,
    });
    response.data[rnd].word.split("").map((letter) => {
      setLetters((prevLetters) => [
        ...prevLetters,
        {
          id: Math.random(),
          letter: letter,
        },
      ]);
    });
  };

  /*
  const handleSettings = async () => {
    const response = await makeGetRequest(
      urls.activitiesUserSettings,
      "",
      true
    );
    const settings = response.data[0];
    setAllowImages(settings.allow_images);
    setTimer(settings.timer);
    setErrorChecking(settings.error_checking);
  };*/

  const handleResetGame = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (timesPlayed > 0) {
      setOpenGameStartModal(true);
    }
  }, [timesPlayed]);

  useEffect(() => {
    if (resetGame === 1) {
      handleResetGame();
    }
  }, [resetGame]);

  useEffect(() => {
    if (letters.length === 0) {
      handleGetData();
      //handleSettings();
    }
  },[])

  useEffect(() => {
    if(dndEngine === undefined && word.word != ""){
      setEngine()
    }
  },[word])

  const setEngine = () => {
    if(word.word != ""){
      if(('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0)){
      setDNDEngine(<DndProvider backend={TouchBackend}>
                      <Card style={{ padding: "10px", margin: "10px", marginTop: "50px" }}><Goals
                          phrase={phrase}
                          letters={letters}
                          word={word.word}
                          answer={word.answer}
                          setPlay={setPlay}
                          errorChecking={errorChecking}
                          setTimesPlayed={setTimesPlayed}
                        />
                        <LetterContainer letters={letters.sort((a, b) => a.id - b.id)} />
                          </Card>
                        </DndProvider>)
      setDNDEngineReady(true)
     }else{
      setDNDEngine(<DndProvider backend={HTML5Backend}>
                      <Card style={{ padding: "10px", margin: "10px", marginTop: "50px" }}>
                        <Goals
                          phrase={phrase}
                          letters={letters}
                          word={word.word}
                          answer={word.answer}
                          setPlay={setPlay}
                          errorChecking={errorChecking}
                          setTimesPlayed={setTimesPlayed}
                        />
                        <LetterContainer letters={letters.sort((a, b) => a.id - b.id)} />
                          </Card>
                        </DndProvider>)
      setDNDEngineReady(true)
     };
     setDNDEngineReady(false)
    }
  }

  return (
    <>
    {!dndEngineReady ? <>
                    <BackToGameList />
                    <div
                      className="main-content"
                      style={{ margin: "20px", background: "rgb(240, 244, 249)" }}
                    >
                      <GameStart
                        timer={timer}
                        time={time}
                        play={play}
                        setTime={setTime}
                        openGameStartModal={openGameStartModal}
                        timesPlayed={timesPlayed}
                        setResetGame={setResetGame}
                        onGameStartModal={setOpenGameStartModal}
                        gameTitle={"Letter Scramble"}
                        gameDescription={`To play, touch the "Start Game" button. 
                        Then touch and drag letters into the order that matches the description.
                        Thank you for playing, and enjoy!`}
                      />
                      {dndEngine}
                    </div>
                    </> : <>Loading...</>}
                  </>
    )
}
export default LetterScramble;
